var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 353 353",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#35A4DD",
    d: "M4.03 64.84c-.02.384-.03.77-.03 1.16v211c0 17.397 14.103 31.5 31.5 31.5h281c17.397 0 31.5-14.103 31.5-31.5V66c0-.389-.01-.775-.031-1.16a11.459 11.459 0 01-3.729 7.666L325 90.013V269.34l-94.337-93.487-17.034 15.5 95.002 94.146H43.819l91.775-95.143-16.915-15.593L27 269.807V90.243L7.705 72.455a11.46 11.46 0 01-3.674-7.615z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9AF17",
    d: "M254.5 55.5c0 6.351-5.149 11.5-11.5 11.5s-11.5-5.149-11.5-11.5S236.649 44 243 44s11.5 5.149 11.5 11.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9AF17",
    d: "M23.5 44.5C12.752 44.5 4.034 53.196 4 63.937a11.568 11.568 0 00.053 1.168 11.457 11.457 0 003.652 7.35l159.451 147a11.502 11.502 0 0015.535.051l161.549-147A11.459 11.459 0 00348 63.93c-.037-10.738-8.754-19.431-19.5-19.431H278c-6.351 0-11.5 5.149-11.5 11.5s5.149 11.5 11.5 11.5h37.566L175.002 195.405 36.262 67.5H207c6.351 0 11.5-5.149 11.5-11.5s-5.149-11.5-11.5-11.5H23.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default ForwardRef;